<template>
  <div class="home">
    <span style="background: #fff; display: block;padding: 10px;">
      <!-- 搜索条件 -->
      <span style="margin-bottom:10px;display: block;">
        <el-form ref="form" label-width="87px" style="display: flex;align-items: center;">
          <el-form-item label="日期">
            <div style="display: flex;align-items: baseline;">
              <el-date-picker v-model="deductionFeeDay" type="month" value-format="timestamp" placeholder="选择月">
              </el-date-picker>
              <el-button type="primary" size="mini" @click="getDataList">查询</el-button>
              <el-button type="primary" style="margin-left:15px;" size="mini" @click="exportList">导出excel<i
                  class="el-icon-download"></i></el-button>
            </div>
          </el-form-item>
        </el-form>
      </span>
      <!-- 表格内容 -->
      <el-table stripe :data="tableData" border id="tabled" v-loading="loading">
        <el-table-column label="指标名称" prop="a" width="260" />
        <el-table-column label="计量单位" prop="b" width="190" />
        <el-table-column label="代码" width="190">
          <template slot-scope="scope">
            <span>{{scope.row.c}}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="190">
          <template slot-scope="scope">
            <span>{{scope.row.d}}</span>
          </template>
        </el-table-column>

      </el-table>
    </span>
  </div>
</template>
<script>
  import request from "@/api/http.js";//axios ajax请求
  export default {
    data () {
      return {
        loading: false,//等待
        dataNum: {},//数值
        quota: [],//公共机构能源资源消费状况数据
        findEnterpriseInformation: {},//01公共机构基本信息 数据
        deductionFeeDay: '',//日期
        tableData1: [ // 第1页数据
          {
            a: '单位详细名称',
            b: '国家税务总局陕西省税务局',
          },

        ],
        // 第二页数据
        tableData: [{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '其中：太阳能光热利用系统集热器面积',
          b: '平方米',
          c: '009',
          d: '',
        },{
          a: '用地面积',
          b: '平方米',
          c: '009',
          d: '',
        },],
      };
    },
    mounted () {
      var date=new Date();
      date.setDate(1);
      this.deductionFeeDay=new Date(date.toLocaleDateString()).getTime(); //默认时间当月一号
      // 获取数据
      this.getDataList();
    },
    methods: {
      // 导出excel
      tablesToExcel (jsonData,wbname,appname) {
        var url='data:application/vnd.ms-excel;base64,',
          tmplWorkbookXML='<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">'
            +'<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>Axel Richter</Author><Created>{created}</Created></DocumentProperties>'
            +'<Styles>'
            +'<Style ss:ID="Currency"><NumberFormat ss:Format="Currency"></NumberFormat></Style>'
            +'<Style ss:ID="Date"><NumberFormat ss:Format="Medium Date"></NumberFormat></Style>'
            +'</Styles>'
            +'{worksheets}</Workbook>'
          ,tmplWorksheetXML='<Worksheet ss:Name="{nameWS}"><Table border="1"><ss:Column ss:Width="220"/><ss:Column ss:Width="160"/><ss:Column ss:Width="120"/><ss:Column ss:Width="120"/><ss:Column ss:Width="120"/><ss:Column ss:Width="160"/>{rows}</Table></Worksheet>'
          ,tmplCellXML='<Cell><Data ss:Type="{nameType}">{data}</Data></Cell>'
          ,base64=function(s) {
            return window.btoa(unescape(encodeURIComponent(s)))
          }
          ,format=function(s,c) {
            return s.replace(/{(\w+)}/g,function(m,p) {
              return c[p];
            })
          }

        var ctx="";
        var workbookXML="";
        var worksheetsXML="";
        var rowsXML="";
        var pil=0;

        for(var i=0;i<this.tableData1.length;i++) {
          if(i==0) {//第一也表头
            rowsXML=`
            <Row><Cell ss:MergeAcross="4" ><Data ss:Type="String">01公共机构基本信息</Data> </Cell></Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String">单位盖章：国家税务总局陕西省税务局</Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2" > 
                <Data ss:Type="String">表    号：${this.findEnterpriseInformation.tableNum}</Data>
              </Cell>
            </Row>
            <Row> 
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">制定机关：${this.findEnterpriseInformation.formulateUnit}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">批准机关：${this.findEnterpriseInformation.ratifyUnit}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">批准文号：${this.findEnterpriseInformation.ratifyCode}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">有效期至：${this.findEnterpriseInformation.validTime}</Data>
              </Cell>
            </Row>
            <Row> 
              <Cell > 
                <Data ss:Type="String">${this.parseTime(this.deductionFeeDay,'{y}年{m}月')}</Data>
              </Cell>
            </Row>
            `

          }
          // 第一页数据
          rowsXML+='<Row>';
          for(var key in this.tableData1[i]) {
            ctx={
              nameType: 'String',
              data: this.tableData1[i][key]
            };
            rowsXML+=format(tmplCellXML,ctx);
          }
          rowsXML+='</Row>';

          if(i==this.tableData1.length-1) {
            // 第一页结尾数据
            rowsXML+=`
            <Row><Cell ></Cell></Row>
            <Row>
              <Cell  >
                <Data ss:Type="String">单位负责人：</Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String">统计负责人：</Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String">填表人：</Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String"> </Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String">联系电话：</Data></Cell> 
              </Cell>
            </Row>
            <Row><Cell ></Cell></Row>
            <Row><Cell ><Data ss:Type="String">说明：</Data></Cell></Row>
            <Row><Cell ><Data ss:Type="String">1.组织机构代码和统一社会信用代码仅需填写其中一项。已经领取了统一社会信用代码的法人单位和产业活动单位必须填写统一社会信用代码。在填写时，要按照《营业执照》（证书）上的统一社会信用代码填写。未领取统一社会信用代码的，填写组织机构代码。</Data></Cell></Row>
            <Row><Cell ><Data ss:Type="String">2.单位负责人指本单位主管节能工作的领导；统计负责人指本单位负责节能工作的处（科、室）领导；填表人指本单位具体负责填写能耗统计报表的人员</Data></Cell></Row>
            `

            pil++;
            ctx={rows: rowsXML,nameWS: '01公共机构基本信息'};
            worksheetsXML+=format(tmplWorksheetXML,ctx);//保存第一页
            // 第二页表头
            rowsXML=`
            <Row><Cell ss:MergeAcross="4" ><Data ss:Type="String">01公共机构基本信息</Data> </Cell></Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String">单位盖章：国家税务总局陕西省税务局</Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2" > 
                <Data ss:Type="String">表    号：${this.findEnterpriseInformation.tableNum}</Data>
              </Cell>
            </Row>
            <Row> 
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">制定机关：${this.findEnterpriseInformation.formulateUnit}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">批准机关：${this.findEnterpriseInformation.ratifyUnit}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">批准文号：${this.findEnterpriseInformation.ratifyCode}</Data>
              </Cell>
            </Row>
            <Row>
              <Cell ss:MergeAcross="1" ss:MergeDown="4">
                <Data ss:Type="String"></Data></Cell> 
              </Cell>
              <Cell ss:MergeAcross="2"> 
                <Data ss:Type="String">有效期至：${this.findEnterpriseInformation.validTime}</Data>
              </Cell>
            </Row>
            <Row> 
              <Cell > 
                <Data ss:Type="String">${this.parseTime(this.deductionFeeDay,'{y}年{m}月')}</Data>
              </Cell>
            </Row>
            `
            // 第二页数据
            rowsXML+='<Row>'+
              '<Cell><Data ss:Type="String">指标名称</Data></Cell>'+
              '<Cell><Data ss:Type="String">计量单位</Data></Cell>'+
              '<Cell><Data ss:Type="String">代码</Data></Cell>'+
              '<Cell><Data ss:Type="String">数量</Data></Cell></Row>';

            for(let e=0;e<jsonData.length;e++) {
              rowsXML+='<Row>';
              for(var key in jsonData[e]) {
                ctx={
                  nameType: 'String',
                  data: jsonData[e][key]
                };
                rowsXML+=format(tmplCellXML,ctx);
              }
              rowsXML+='</Row>';
            }
            // 第二页结尾
            rowsXML+=`
            <Row><Cell ></Cell></Row>
            <Row>
              <Cell  >
                <Data ss:Type="String">单位负责人：</Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String">统计负责人：</Data></Cell> 
              </Cell>
              <Cell  >
                <Data ss:Type="String">填表人：</Data></Cell> 
              </Cell> 
              <Cell  >
                <Data ss:Type="String">联系电话：</Data></Cell> 
              </Cell>
            </Row>
            <Row><Cell ></Cell></Row>
            <Row><Cell ><Data ss:Type="String">说明：</Data></Cell></Row>
            <Row><Cell ><Data ss:Type="String">单位负责人指本单位主管节能工作的领导；统计负责人指本单位负责节能工作的处（科、室）领导；填表人指本单位具体负责填写能耗统计报表的人员。</Data></Cell></Row> 
            `
          }

        }
        ctx={rows: rowsXML,nameWS: '02公共机构能源资源消费状况'};
        worksheetsXML+=format(tmplWorksheetXML,ctx);//保存第二页
        rowsXML="";
        ctx={created: (new Date()).getTime(),worksheets: worksheetsXML};//合并
        workbookXML=format(tmplWorkbookXML,ctx);
        var link=document.createElement("A");
        link.href=url+base64(workbookXML);
        link.download=wbname||'Workbook.xls';
        link.target='_blank';
        document.body.appendChild(link);
        link.click();//导出
        document.body.removeChild(link);
      },
      // 获取抄表列表信息
      getDataList () {
        this.loading=true;
        setTimeout(() => {
          this.loading=false;
        },3000);
        var params={
          dateTypeEnum: 'MON',
          time: this.deductionFeeDay,
          unitId: this.$store.unitStore.getters.getNowUnit.id
        }
        //数值
        request({url: "/quota/findSpecialEnergyTypeNumericalByTime",method: "get",params}).then(res => {

          if(res.code==200) {
            this.dataNum={};
            res.data.map(v => {
              this.dataNum[v.specilaId]=v.numerical;
            })
            //公共机构能源资源消费状况数据
            request({url: "/quota/findAllSpecialEnergyType",method: "get"}).then(res => {
              if(res.code==200) {
                this.quota=[];
                res.data.map((v,i) => {
                  if(v.state==0) {
                    v.numerical=this.dataNum[v.id]||0;
                    this.quota.push({
                      a: v.itemName,
                      b: v.measuringUnit,
                      c: v.itemCode,
                      d: v.numerical,
                    })
                  }

                })
              }

              var params={
                unitId: this.$store.unitStore.getters.getNowUnit.id
              }
              //01公共机构基本信息 数据
              request({url: "/quota/findEnterpriseInformation",method: "get",params}).then(res => {
                this.loading=false;
                if(res.code==200) {
                  this.findEnterpriseInformation=res.data;
                  this.tableData=this.quota
                  this.tableData1=[
                    {
                      a: '单位详细名称',
                      b: this.findEnterpriseInformation.unitName,
                    },
                    {
                      a: '组织机构代码',
                      b: this.findEnterpriseInformation.unitCode,
                    },
                    {
                      a: '统一社会信用代码',
                      b: this.findEnterpriseInformation.unifiedSocialCode,
                    },
                    {
                      a: '机构类型',
                      b: this.findEnterpriseInformation.unitType,
                    },
                    {
                      a: '行业代码',
                      b: this.findEnterpriseInformation.industryCode,
                    },
                    {
                      a: '单位地址',
                      b: this.findEnterpriseInformation.unitAddress,
                    },
                    {
                      a: '单位所在地区代码',
                      b: this.findEnterpriseInformation.unitAddressCode,
                    },
                    {
                      a: '联系电话',
                      b: this.findEnterpriseInformation.phone,
                    },
                    {
                      a: '其他',
                      b: this.findEnterpriseInformation.rests,
                    },
                  ]
                }
              })
            })
          }
        })



      },

      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 下载excel
      exportList () {
        const tHeader='2023年';
        this.tablesToExcel(this.tableData,'2023年1月月报','Excel')

      },

    }
  };
</script>

<style lang="scss" scoped>
  .home {
    box-sizing: border-box;
    background-color: #e9ebef;
    padding: 10px;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }
</style>